<template>
  <div class="--addresses-tab animated fadeIn">
    <b-row>
      <b-col>
        <div class="card">
          <div class="card-header">
            <i class="fa fa-align-justify"></i>
            Addresses List
            <div class="pull-right tools">
              <edit-address
                :hideAddButton="false"
                :companyId="companyId"
                :id="activeEditId"
                ref="editModal"
                @hideModal="hideAddressModal"
                @saved="refreshAddressList"
              ></edit-address>
            </div>
          </div>
          <grid-component
            isResizable
            isReorderable
            :gridId="gridId"
            :itemData="addressesList"
            :fields="fields"
            :handleRowClick="onEdit"
            :onDelete="onDelete"
            :navigationField="'name'"
          />
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import debounce from 'lodash/debounce';

import { GRID_ID, SAVE_SETTINGS_DELAY } from '@/shared/constants';
import { prepareColumnsData } from '@/shared/helpers';
import GridSettings from '@/shared/components/GridSettings';

import AddressDto from './dto';
import addressFields from './fields';
import EditAddress from './components/EditAddress/index';
import GridComponent from '@/shared/components/GridComponent';

export default {
  name: 'AddressesTab',
  components: {
    GridSettings,
    EditAddress,
    GridComponent
  },
  data() {
    return {
      prepareColumnsData,
      address: {},
      currentTypeId: 1,
      fields: addressFields,
      buttonsHeaderVisible: true,
      gridId: GRID_ID.ADDRESSES,
      activeEditId: 0,
    };
  },
  computed: {
    ...mapGetters('companies', ['companyById']),
    company() {
      return this.companyById(this.companyId);
    },
    companyId() {
      return this.$route.params.id;
    },
    ...mapGetters('address', [
      'addressesList',
      'addressTypes',
      //'countryCodes',
    ]),
    ...mapGetters('account', ['gridSettingsById']),
    gridSettings() {
      return this.gridSettingsById(GRID_ID.ADDRESSES);
    },
  },
  methods: {
    ...mapActions('address', [
      'getAddresses',
      //'getAddressTypes',
      //'getAddressById',
      //'getCountryCodes',
      /*'deleteAddress',*/
      'deleteRecord',
    ]),
    ...mapActions('quoteDetails', ['getContacts']),
    ...mapActions('account', ['saveGridSettings']),
    async refreshAddressList() {
      await this.getAddresses(this.company.id);

      // await this.getAddressTypes();

      // this.addressesList.forEach(
      //   x =>
      //     (x.addressTypeName = this.addressTypes
      //       .filter(y => y.id == x.addressTypeId)
      //       .map(z => z.name)
      //       .pop())
      // );
    },

    async onAddNewAddress() {
      this.$v.address.$touch();

      if (this.$v.address.$invalid) {
        this.openAlertBox({message: 'The entered data is incorrect. Enter new correct data'});
        return;
      }

      this.address.id = 0;
      this.address.accountId = this.company.id;
      this.address.addressTypeId = this.currentTypeId;

      await this.addNewAddress(this.address);

      this.onClear();
      this.refreshAddressList();
    },

    async onEditAddress() {
      this.$v.address.$touch();

      if (this.$v.address.$invalid) {
        this.openAlertBox({message: 'The entered data is incorrect. Enter new correct data'});
        return;
      }

      this.address.accountId = this.company.id;
      this.address.addressTypeId = this.currentTypeId;

      await this.editAddress(this.address);

      this.onClear();
      this.refreshAddressList();
    },

    onClear() {
      this.address = new AddressDto();
      this.address.isDefault = false;
      this.$v.address.name.$reset();
    },

    async onEdit({ dataItem }) {
      this.activeEditId = dataItem.id;
      this.$bvModal.show('edit-address-modal');
    },

    async onDelete(item) {
      const deleteConfirmed = await this.openConfirmBox({message:`Are you sure you want to delete address: "${item.name}"?`});
      if (deleteConfirmed) {
        /*await this.deleteAddress(item.id);*/
        const result = await this.deleteRecord(item.id);

        if (result.status == 200) {
          this.$snotify.success('Address deleted succesfully');
        }
        else {
          this.$snotify.error('Address deleting failed');
        }
        await this.refreshAddressList();
      }
    },
    async hideAddressModal() {
      this.activeEditId = 0;
    },
    handleColumnResize: debounce(function ({ columns }) {
      const newColumns = prepareColumnsData({
        columns,
        initialColumns: addressFields,
        settingsColumns: this.gridSettings.columns,
      });

      this.saveGridSettings({
        id: GRID_ID.ADDRESSES,
        settings: { columns: newColumns },
      });
    }, SAVE_SETTINGS_DELAY),
    handleColumnReorder({ columns }) {
      const newColumns = prepareColumnsData({
        columns,
        initialColumns: addressFields,
        settingsColumns: this.gridSettings.columns,
      });

      this.saveGridSettings({
        id: GRID_ID.ADDRESSES,
        settings: { columns: newColumns },
      });
    },
  },
  mounted() {
    this.refreshAddressList();
    this.getContacts(this.companyId);
    //this.getCountryCodes();
    this.address = new AddressDto();
    this.address.isDefault = false;
  },
};
</script>

<style lang="scss">
.company--addresses-tab {
  .form-actions {
    .btn {
      margin-left: 10px;
      margin-bottom: 10px;
    }
  }
  .buttonHeader {
    position: fixed;
    top: 15%;
    left: 80%;
    z-index: 7;
  }
  .cancelButton {
    margin-right: 10px;
  }
}
</style>
